var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewsMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 15 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.167 12q-.55 0-.942-.392a1.28 1.28 0 0 1-.392-.941V1.333q0-.55.392-.941Q1.616 0 2.167 0h10.666q.55 0 .942.392.392.391.392.941v9.334q0 .55-.392.941a1.28 1.28 0 0 1-.942.392zm0-1.333h10.666V1.333H2.167zM3.5 9.333h8V8h-8zm0-2.666h2.667v-4H3.5zm4 0h4V5.333h-4zM7.5 4h4V2.667h-4z"
})));
export default SvgNewsMode;